import React, { Suspense } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Box } from "@chakra-ui/core";

import Page404 from "../pages/Page404";
import { MentorHomePage } from "../pages/Dashboard/Mentor/MentorHome";
import { ProfilePage } from "../pages/Dashboard/Mentor/ProfilePage";

export const MentorDashboardNavigator = (props) => {
  const { path } = useRouteMatch();

  return (
    <Box onClick={props.toggle}>
      <Switch>
        <Route path={`${path}/me`} component={ProfilePage} />

        <Route path={path} exact>
          <MentorHomePage />
        </Route>
        <Route path={`${path}/page-not-found`} component={Page404} />

        <Redirect to={`${path}/page-not-found`} />
      </Switch>
    </Box>
  );
};
